import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import * as PropTypes from 'prop-types';
import SpzaComponent from './spzaComponent';
import FuturePriceTooltip from 'components/futurePriceTooltip';
export class SimplePriceCell extends SpzaComponent {
    renderImpl() {
        const { price, futurePrice, className } = this.props;
        return /*#__PURE__*/ _jsxs("div", {
            className: `simplePriceCell ${className}`,
            children: [
                /*#__PURE__*/ _jsx("span", {
                    className: "price",
                    // eslint-disable-next-line react/no-danger
                    dangerouslySetInnerHTML: {
                        __html: price
                    }
                }),
                futurePrice && /*#__PURE__*/ _jsx(FuturePriceTooltip, {
                    futurePrice: futurePrice
                })
            ]
        });
    }
}
SimplePriceCell.contextTypes = {
    renderErrorModal: PropTypes.func
};
